import { CellDecorator } from '../Enum/TableDecorator';
import { Cell, HeaderCell, InterestTableDTO, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { News } from '../Interface/Response/Interest/News';
import { Label } from '../Interface/Response/Interest/Label';
import { ReducerInterface } from '../Interface/News/NewsInterface';

interface RowConstructor {
    (label: Label, curValue: News): Row;
}

const reduceTable = (
    news: News[],
    allLabels: Label[],
    rowConstructor: RowConstructor,
): InterestTableDTO => {
    const headers: HeaderCell[] = [
        {
            value: '',
            prop: 'Verstrekker',
        },
        {
            value: 'Product',
            prop: 'Product',
        },
        {
            value: 'Datum',
            prop: 'Datum',
        },
        {
            value: 'Pdf',
            prop: 'Pdf',
        },
    ];

    const data = news.reduce((acc: Row[], curValue: News) => {
        const label = allLabels.find(({ findataCode }) => findataCode === curValue.label);

        if (label === undefined) {
            return acc;
        }

        return [...acc, rowConstructor(label, curValue)];
    }, []);

    return { data, headers };
}

export const reduceInterestTableNewsData: ReducerInterface = (news: News[], allLabels: Label[]): InterestTableDTO => {
    const rowConstructor: RowConstructor = (label, curValue) => {
        const cells: Cell[] = [
            { value: label.findataCode, decorator: CellDecorator.CompanyIcon },
            { value: { label: label.label, type: curValue.type }, decorator: CellDecorator.LabelDeviation },
            { value: curValue.date, decorator: CellDecorator.Date },
            { value: { ...curValue }, decorator: CellDecorator.ExportPDF },
        ];

        return { cells };
    }

    return reduceTable(news, allLabels, rowConstructor);
};

export const reducePropertiesTableNewsData: ReducerInterface = (news: News[], allLabels: Label[]): InterestTableDTO => {
    const rowConstructor: RowConstructor = (label, curValue) => {
        const cells: Cell[] = [
            { value: label.findataCode, decorator: CellDecorator.CompanyIcon },
            { value: label.label },
            { value: curValue.date, decorator: CellDecorator.Date },
            { value: { ...curValue, disableExternal: true }, decorator: CellDecorator.ExportPDF },
        ];

        return { cells };
    }

    return reduceTable(news, allLabels, rowConstructor);
}
